import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { permissionService } from "../../services/PermissionService";
import FunctionalitySet from "./FunctionalitySet";

export default function EditUserPermissions(props) {
  const [userpermissions, setUserPermissions] = useState({});
  const { t } = useTranslation();
  let history = useHistory();
  useEffect(() => {
    permissionService
      .getUserPermissions(props.match.params.userId)
      .then((data) => {
        setUserPermissions(data);
      });
  }, []);

  function changeFunctionality(event, functionalityId, setName) {
    var index = userpermissions.functionalities[setName]
      .map((x) => x.id)
      .indexOf(functionalityId);
    let _userpermissions = { ...userpermissions };
    _userpermissions.functionalities[setName][index].selected =
      event.target.checked;
    setUserPermissions(_userpermissions);
  }

  function save() {
    let functionalities = [];
    for (let key in userpermissions.functionalities) {
      for (let item of userpermissions.functionalities[key]) {
        if (item.selected) functionalities.push(item.id);
      }
    }
    permissionService
      .saveUserFunctionalities(props.match.params.userId, functionalities)
      .then(() => toast.success(t("Functionality changed successfully")));
  }
  
  return (
    <>
      <div className="row m-2">
        <div className="col">
          <p>
            {t("Name")}: {userpermissions.fullName}
          </p>
          <p>
            {t("Email")}: {userpermissions.email}
          </p>

          <p>
            {t("Roles")}:{" "}
            {userpermissions.roles &&
              userpermissions.roles.map((role) => `${t(role)}*`)}
          </p>
        </div>
        <div className="col text-end">
          <button
            className="btn app-button btn-second btn-lg"
            onClick={() => history.push("/Permissions")}
          >
            {t("Cancel")}
          </button>
          <button className="app-button btn-prime btn-lg" onClick={save}>
            {t("Save")}
          </button>
        </div>
      </div>

      <div class="accordion" id="functionalities">
        {userpermissions.functionalities &&
          Object.keys(userpermissions.functionalities).map((key) => (
            <FunctionalitySet
              funtionalities={userpermissions.functionalities[key]}
              functionalitySetName={key}
              changeFunctionality={changeFunctionality}
            />
          ))}
      </div>
    </>
  );
}
